/** Смещает горизонтальный скролл так, чтобы левый край колонки совпал с viewport доски. */
export function scrollBoardColumnIntoWorkspace(
  scrollContainer: HTMLElement,
  column: HTMLElement,
  behavior: ScrollBehavior = 'smooth',
): void {
  const containerRect = scrollContainer.getBoundingClientRect();
  const columnRect = column.getBoundingClientRect();
  const delta = columnRect.left - containerRect.left;
  const next = scrollContainer.scrollLeft + delta;
  scrollContainer.scrollTo({ left: Math.max(0, next), behavior });
}

export function isCrmBoardDesktopLayout(): boolean {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(min-width: 1024px)').matches;
}
